import { render } from "./Taxcodes.vue?vue&type=template&id=89a8bf86&scoped=true"
import script from "./Taxcodes.vue?vue&type=script&lang=js"
export * from "./Taxcodes.vue?vue&type=script&lang=js"

import "./Taxcodes.vue?vue&type=style&index=0&id=89a8bf86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a8bf86"]])

export default __exports__